import {
  Component,
  OnInit,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  Output,
  Input,
} from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '@/app/services/shared/stage2.service';

import { ProjectsService } from '@/app/services/projects/projects.service';
import { ProjectStageApproverResponse } from '@/app/interfaces/project-stage-approver.interface';

// import { AccordionComponent } from '../accordion/accordion.component';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { WorkPackagesComponent } from './workpackages/workpackages.component';

// IMP: Need these imports so that we can use them in .html files
import { ManualGeneratedComponent } from './custom-generated/manual-generated/manual-generated.component';
import { CostEstimationComponent } from './cost-estimation/cost-estimation.component';
import { RaciMatrixComponent } from './raci-matrix/raci-matrix.component';
import { RiskAssessmentComponent } from './risk-assessment/risk-assessment.component';
import { SendforapprovalComponent } from '@/app/components/projects/project-stages/project-brief/sendforapproval/sendforapproval.component';
import { ProjectStageApprovalComponent } from '@/app/components/projects/project-stages/project-stage-approval/project-stage-approval.component';
import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';
import { ViewportScroller } from '@angular/common';
import { Stage2viewmodeComponent } from './stage2viewmode/stage2viewmode.component';
import { VIEW_MODE } from '@/app/interfaces/view-mode.enum';
import { ProgressService } from '@/app/services/shared/progress.service';
import { TabbedScrollerComponent } from '../tabbed-scroller/tabbed-scroller.component';
import { WorkPackageInterface } from './workpackages/workpackages.component';
import { GetProjectIdService } from '@/app/services/getProjectId.service';

@Component({
  selector: 'app-plan-sections',
  standalone: true,
  imports: [
    MatSelectModule,
    CommonModule,
    WorkPackagesComponent,
    ManualGeneratedComponent,
    CostEstimationComponent,
    RaciMatrixComponent,
    RiskAssessmentComponent,
    SendforapprovalComponent,
    NgxPageScrollCoreModule,
    ProjectStageApprovalComponent,
    Stage2viewmodeComponent,
  ],
  templateUrl: './plan-sections.component.html',
  styleUrl: './plan-sections.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PlanSectionsComponent implements OnInit {
  @Input() currentStep!: number;
  projectId!: number | null | string;
  @Output() changeStages: EventEmitter<any> = new EventEmitter<any>();

  categories: string[] = ['NRM 1', 'NRM 2', 'NBS', 'Custom'];
  selectedCategory = '';
  subCategories: string[] = ['AI Generated', 'Manual'];
  selectedSubCategory = '';

  showApprovalComponent = false;
  showProjectStageApproval = false;

  
  originalCollection: WorkPackageInterface[] = [];
  collectionL: WorkPackageInterface[] = [];
  collectionR: WorkPackageInterface[] = [];
  selectedParentWP: WorkPackageInterface | undefined;
  isEdit: boolean = false;

  STAGE_NUMBER = 2;

  isEditMode = true; // Default to View mode

  VIEW_MODE = VIEW_MODE;
  mode: VIEW_MODE = VIEW_MODE.EDIT;

  progress = 0;
  

  constructor(
    private viewportScroller: ViewportScroller,
    private router: Router,
    private dataService: DataService,
    private projectsService: ProjectsService,
    private progressService: ProgressService,
    private TabbedScrollerComponent: TabbedScrollerComponent,
    private getProjectIdService: GetProjectIdService
  ) {}

  ngOnInit() {
    this.progressService.progress2$.subscribe((value) => {
      this.progress = value;
    });

    this.projectId = this.getProjectIdService.getProjectId();
    this.triggerSavedWorkPackagesData(this.projectId);
    this.currentStep = this.TabbedScrollerComponent.currentStep;
    console.log("Proejct id in plan section: ", this.projectId);
    
  }

  triggerSavedWorkPackagesData(project_Id: number | string) {
    this.projectsService.getSavedWorkPackagesDetails(project_Id).subscribe({
      next: (response) => {  
        if (
          response?.meta?.success &&
          response?.data &&
          Object.keys(response.data).length > 0
        ) {
          this.isEdit = true;
          this.collectionL = response?.data?.collectionL;
          this.collectionR = response?.data?.collectionR;
          this.originalCollection = response?.data?.mainParent.children;
          this.selectedParentWP = response?.data?.mainParent;
        }
      },
      error: (error) => {
        console.error('Error fetching WPSI:', error);
      },
    });
  }

  scrollTo = (anchor: string): void => {
    this.viewportScroller.scrollToAnchor(anchor);
  };

  onDataChangeFromSubChild(data: any) {
    console.log('Data received from RaciMatrixComponent:', data);
    this.changeStages.emit(data); // Emit data to parent
  }

  callWorkPackages() {
    this.triggerSavedWorkPackagesData(this.projectId);
  }

  onCategoryChange() {
    // If selectedCategory is not 'Custom', reset selectedSubCategory
    if (this.selectedCategory !== 'Custom') {
      this.selectedSubCategory = '';
    }
  }

  // TODO: we need to pass data to project-stage-approval-component here
  checkProjectStageApprovers(projectId: number, stageId: number) {
    this.projectsService
      .getProjectStageApprovals(projectId, stageId)
      .subscribe({
        next: (response: ProjectStageApproverResponse) => {
          this.showProjectStageApproval =
            response.meta.success && response.data && response.data.length > 0;
        },
        error: (error) => {
          console.error('Error fetching project stage approvers:', error);
          this.showProjectStageApproval = false;
        },
        complete: () => {
          console.log('Completed');
          
        },
      });
  }

  handleViewChange($event: any) {
    this.mode = $event;
  }

  toggleMode(): void {
    this.isEditMode = !this.isEditMode;
    if (this.isEditMode) {
      this.mode = VIEW_MODE.EDIT;
    } else {
      this.mode = VIEW_MODE.VIEW;
    }
    console.log('Switched to', this.isEditMode ? 'Edit Mode' : 'View Mode');
  }
  clickEditProjectBrief() {
    localStorage.setItem('isEdit', String(true));
  }
}
